import { render, staticRenderFns } from "./CustomLanguage.vue?vue&type=template&id=0cf9319b&scoped=true&"
import script from "./CustomLanguage.vue?vue&type=script&lang=js&"
export * from "./CustomLanguage.vue?vue&type=script&lang=js&"
import style0 from "./CustomLanguage.vue?vue&type=style&index=0&id=0cf9319b&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf9319b",
  null
  
)

export default component.exports